import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const ContainerBack = styled.div`
  display: grid;
  grid-template-columns: 27vw 1fr;
`;

export const ContentBack = styled.div`
  display: grid;
  grid-template-columns: 7vw 9vw 12vw;
  align-items: center;
`;

export const ButtonBack = styled.button`
    background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 56.52px;
  height: 25px;
  margin: 0px auto;
  text-align: left;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const HeaderDetail = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  .heading-container {
    margin-left: 2rem;
    margin-top: 4rem;
    width: 85%;
    border-bottom: 2px solid ${({ theme }) => theme.neutral.gray[700]};
  }
`;

export const TitleOfDetail = styled.h3`
  text-transform: capitalize;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const TitleRegister = styled.h3`
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const TitleAbout = styled.h3`
  font-weight: bold;
  color: ${({ theme }) => theme.neutral.gray[3700]};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 1.143rem;
`;

export const TitleSpeaker = styled.h3`
  font-weight: bold;
  color: ${({ theme }) => theme.primaryColorLight};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[900]};
  height: 2px;
  margin-top: 0.1em;
  width: 10em;
`;

export const ButtonRegister = styled.button`
  border: 2px solid ${({ theme }) => theme.neutral.white};
  background-color: ${({ theme }) => theme.button.primary};
  font-size: 16px;
  font-weight: 600;
  padding: 0.5em 2em;
  text-transform: capitalize;
  color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 3px;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  :hover {
    opacity: 0.8;
  }
`;

export const ButtonCancel = styled.button`
  border: 2px solid ${({ theme }) => theme.neutral.white};
  background-color: ${({ theme }) => theme.button.primary};
  font-size: 16px;
  font-weight: 600;
  padding: 0.5em 2em;
  text-transform: capitalize;
  color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 3px;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  :hover {
    opacity: 0.8;
  }
`;

export const ContentModalReadMore = styled.div`
  position: absolute;
  left: 33.2%;
  right: 35.2%;
  top: 25.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.secondaryGrayLightFour};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
  width: 40em;
`;

export const CloseModalReadMore = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalReadMore = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: left;
  height: 25em;
  overflow-y: auto;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h3 {
    font-weight: 600;
  }
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[950]};
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.border.purpleLight}75;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${({ theme }) => theme.neutral.white}73;
    border-radius: 10px;
  }
`;

export const DateEvent = styled.p`
  color: ${({ theme }) => theme.text.primary};
  font-weight: 600;
`;

export const MeetingLink = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.button.primary};
  :hover {
    color: ${({ theme }) => theme.button.primary};
  }
  overflow-wrap: anywhere;
`;

export const ImgUsa = styled.img`
  width: auto;
  height: 24px;
`;

export const ImgSpain = styled.img`
  width: auto;
  height: 24px;
`;

export const ContainRegister = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  .event-info-container {
    padding-left: 20px;
  }
  .freq-text, .until-text{
    text-transform: capitalize;
  }
`;

export const ContainSpeaker = styled.div``;

export const OtherEvent = styled.div``;

export const TitleOtherEvent = styled.h3`
  font-weight: bold;
  color: ${({ theme }) => theme.secondaryDarkOne};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
`;

export const ButtonReadMoreCancel = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.primaryColorLight};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryGray};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    background: ${({ theme }) => theme.secondayGrayLightFive};
  }
`;

export const SizeImgRating = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row-reverse;
  svg {
    height: 30px !important;
    width: 30px !important;
    cursor: pointer;
  }
  .ImageRating:hover,
  .ImageRating:hover ~ .ImageRating {
    fill: ${({ theme }) => theme.primary.yellowLight} !important;
  }
`;

export const RatingContainer = styled.div`
  margin-top: 20px;
`;

const heightLongOtherEvents = (longOtherEvents) => {
  if (longOtherEvents > 2) {
    if (longOtherEvents > 4) {
      return "30%";
    } else {
      return "43%";
    }
  } else {
    return "100%";
  }
};

const heightLongSpeakers = (longSpeakers) => {
  if (longSpeakers > 3) {
    if (longSpeakers > 6) {
      return "30%";
    } else {
      return "43%";
    }
  } else {
    return "100%";
  }
};

export const useStyles = makeStyles(() => ({
  cardContainer: { width: "100%", height: "100%", marginBottom: "4rem" },
  cardDetailLeft: { paddingLeft: "3rem" },
  cardDetailRight: {
    paddingLeft: "3rem",
  },
  containItems: {
    display: "grid",
    alignItems: "center",
    color: themeConfig.button.primary,
    fontWeight: "600",
    margin: "1em 0",
    gridTemplateColumns: "1fr 2fr",
  },
  containItemsFlex: {
    display: "flex",
    alignItems: "center",
    color: themeConfig.button.primary,
    fontWeight: "600",
    margin: "1em 0",
  },
  icons: { color: themeConfig.button.primary, marginRight: "0.5em" },
  containRegister: {
    margin: "0",
  },
  headerRegister: {
    backgroundColor: themeConfig.neutral.white,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    heigth: "100%",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "auto 2fr",
    marginTop: "2rem",
  },
  containAbout: {
    margin: "20px 0",
    backgroundColor: themeConfig.neutral.white,
  },
  headerDetailAbout: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    height: "100%",
    width: "100%",
  },
  imgSpeaker: {
    width: "100%",
    height: "100%",
    margin: "0 0 1em 0",
    borderRadius: "10px",
    maxWidth: "210px",
    maxHeight: "140px",
  },
  imgOtherEvent: {
    width: "100%",
    height: "100%",
  },
  containSpeakers: (props) => ({
    heigth: "100%",
    width: "100%",
    margin: "0",
    backgroundImage: `url(${props.backgroundSpeaker})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
  }),
  bodySpeakers: {
    backgroundColor: themeConfig.background.secondary,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "4rem 4rem 16vw 4rem",
    heigth: "100%",
    width: "100%",
  },
  rowContainSpeakers: (props) => ({
    width: "80%",
    height: heightLongSpeakers(props.longSpeakers),
  }),
  colCardSpeaker: {
    margin: "1em 0",
  },
  containOtherEvent: {
    width: "100%",
    heigth: "100%",
    margin: "0",
  },
  bodyOtherEvent: {
    backgroundColor: themeConfig.neutral.white,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "4rem 4rem 16vw 4rem",
    heigth: "100%",
    width: "100%",
  },
  rowContainOtherEvents: (props) => ({
    width: "100%",
    height: heightLongOtherEvents(props.longOtherEvents),
  }),
  colCardOtherEvent: {
    width: "100%",
    height: "100%",
    margin: "1em 0",
  },
}));
